import { useTranslation } from '@thoughtspot/i18n';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import React from 'react';
import { TranslationsKeys } from '../util';
export const DeleteConfirmationModal = ({ onDeleteConfirm, onDeleteModalClose, name, isModalOpen, showLoader = false, isMultiSelected = false, }) => {
    const { t } = useTranslation();
    return (React.createElement(Modal, { size: ModalSize.SMALL, title: `${t(TranslationsKeys.CONFIRM_DELETE)} ?`, isOpen: isModalOpen, confirmButton: {
            text: t(TranslationsKeys.MORE_OPTIONS_DELETE),
            onConfirm: onDeleteConfirm,
            isLoading: showLoader,
            isDisabled: showLoader,
        }, dismissButton: {
            text: t(TranslationsKeys.CANCEL),
        }, onDismiss: onDeleteModalClose },
        React.createElement(Vertical, { hAlignContent: "stretch", grow: true },
            React.createElement("div", { "data-testid": "delete-confirmation-body" },
                React.createElement(Typography, { variant: "p", noMargin: true }, isMultiSelected
                    ? t(TranslationsKeys.DELETE_BODY_PLURAL)
                    : t(TranslationsKeys.DELETE_BODY, {
                        1: name,
                    }))))));
};
//# sourceMappingURL=delete-confirmation-modal.js.map